const article = {
	slug: "raci-daci-delay",
	title: "RACI vs DACI: No Framework Prices the Delay",
	date: "6 July 2026",
	updated: null,
	description:
		"Every responsibility framework assigns ownership of the decision. None assigns a cost to the delay. The unlock is not more approval power. It is a default that fires on its own.",
	keywords: [
		"RACI",
		"DACI",
		"decision making",
		"engineering leadership",
		"accountability",
	],
	tldr: "RACI names who is Accountable. DACI even names a Driver. Both assign ownership of the decision. Neither puts a cost on the delay, so stalling stays free. The fix is a default that fires on the deadline: no written objection by Friday, we proceed.",
	readingTime: null,
	provenance:
		"Adapted from my LinkedIn post on RACI, DACI, and the cost of delay, July 2026.",
	provenanceUrl: null,
	series: null,
	artifact: "decision-stall-test",
	markdown: `The people who blocked our rollout for months were not powerful. They were patient.

On paper the RACI was clean. The engineers closest to the work were Responsible and ready to build. A handful of reviewers were Consulted. Every review produced a fresh objection. Nothing shipped, and I kept trying to figure out who was killing it.

I had it backwards. Nobody was killing the decision. Nobody was making it either.

## No framework prices the delay

Here is the thing every responsibility chart misses. RACI names who is Accountable. DACI even names a Driver whose whole job is momentum. Both assign ownership of the decision. Neither one puts a cost on the delay.

That was the entire game. Stalling was free. A reviewer could say "I am not comfortable yet" every week, at no cost to them, while it cost the team weeks. The blockers did not need authority. They needed the clock to never start.

## Engineer the default

So we stopped asking who had the power to say yes. We engineered what happens when nobody says no. No written objection by Friday, we proceed. The way a bill becomes law without a signature. Objections were still welcome. Endless objections were not.

A decision without a deadline is not a decision. It is a meeting that repeats.

If a project has been "almost decided" for a month, stop hunting for the person blocking it. There is not one. You are missing a default.

## Try it

Pick the people in your decision below and see how the accountability actually splits by role. A VP always carries more than a developer or a BA, and the fewer names you add, the more each one holds.`,
};

export default article;
